declare global {
  interface Window {
    fbq: (action: string, event: string) => void;
  }
}

export default function Footer() {
  const handleLineClick = () => {
    if (window.fbq) {
      window.fbq('track', 'Contact');
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-800 to-gray-900 text-white py-12 sm:py-14 md:py-16 px-4 sm:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-3 gap-8 sm:gap-10 md:gap-12 mb-8 sm:mb-10 md:mb-12">
          <div>
            <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4">
              <img 
                src="https://static.readdy.ai/image/f1e8e8819fa7a9a02132dd8ff3c38992/d2be48817a964cd50d93dca55c707411.png" 
                alt="Size Music School Logo" 
                className="h-10 w-10 sm:h-12 sm:w-12 object-contain"
              />
              <h3 className="text-xl sm:text-2xl font-bold">Size Music School</h3>
            </div>
            <p className="text-xs sm:text-sm text-gray-300 leading-relaxed mb-3 sm:mb-4">
              歌い手・歌ってみた特化の音楽教室。<br />
              あなたの「はじめて」を応援します。
            </p>
            <div className="flex gap-3 sm:gap-4">
              <a
                href="https://x.com/SizeMusicSchool"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors cursor-pointer"
              >
                <i className="ri-twitter-x-line text-lg sm:text-xl"></i>
              </a>
              <a
                href="https://www.instagram.com/sizemusicschool/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-lg sm:text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-base sm:text-lg font-bold mb-3 sm:mb-4">教室情報</h4>
            <ul className="space-y-2 sm:space-y-3 text-xs sm:text-sm text-gray-300">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-orange-400 flex-shrink-0 mt-0.5"></i>
                <span>埼玉県さいたま市大宮区東町1丁目46 オガワとうちゅうビル2F</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line text-orange-400 flex-shrink-0 mt-0.5"></i>
                <span>080-5759-3875</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-orange-400 flex-shrink-0 mt-0.5"></i>
                <span className="break-all">musicschool@s-i-z-e.net</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line text-orange-400 flex-shrink-0 mt-0.5"></i>
                <span>平日・土日祝 10:00〜22:00<br />(定休日なし)</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base sm:text-lg font-bold mb-3 sm:mb-4">メニュー</h4>
            <ul className="space-y-2 sm:space-y-3 text-xs sm:text-sm text-gray-300">
              <li>
                <a href="#empathy" className="hover:text-pink-400 transition-colors cursor-pointer">
                  スクールについて
                </a>
              </li>
              <li>
                <a href="#strengths" className="hover:text-pink-400 transition-colors cursor-pointer">
                  コース
                </a>
              </li>
              <li>
                <a href="#instructor" className="hover:text-pink-400 transition-colors cursor-pointer">
                  講師
                </a>
              </li>
              <li>
                <a href="#courses" className="hover:text-pink-400 transition-colors cursor-pointer">
                  料金
                </a>
              </li>
              <li>
                <a href="#faq" className="hover:text-pink-400 transition-colors cursor-pointer">
                  よくある質問
                </a>
              </li>
              <li>
                <a href="#trial-form" className="hover:text-pink-400 transition-colors cursor-pointer">
                  無料体験レッスン
                </a>
              </li>
              <li className="pt-2">
                <a
                  href="https://line.me/R/ti/p/@987fxrfi?ts=01081449&oat_content=url"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={handleLineClick}
                  className="whitespace-nowrap inline-flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-bold px-4 sm:px-6 py-2 sm:py-3 rounded-full transition-all duration-300 cursor-pointer text-xs sm:text-sm"
                >
                  <i className="ri-line-fill text-base sm:text-xl"></i>
                  LINEで相談
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 sm:pt-8 text-center">
          <p className="text-xs sm:text-sm text-gray-400">
            &copy; 2024 Size Music School. All rights reserved. | 
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-pink-400 transition-colors ml-2 cursor-pointer"
            >
              Powered by Readdy
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
